import { Component } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

// Interface for a BoxPlotDataPoint
export interface BoxPlotDataPoint {
  x: string;
  y: number[];
  goals?: { [key: string]: number | string }[]; // holds outliers/markers
}

// Interface for the BoxPlotSeries
export interface BoxPlotSeries {
  name: string;
  data: BoxPlotDataPoint[];
}

interface BoxAndWhiskerPlotProps {
  options: ApexOptions;
  series: BoxPlotSeries[];
  height?: number | string;
  width?: number | string;
  /** When true, do not enforce a 200px minimum height so the chart can shrink inside flex layouts. */
  fillContainer?: boolean;
}

interface BoxAndWhiskerPlotState {
  options?: ApexOptions;
  series?: BoxPlotSeries[];
}

class BoxAndWhiskerPlot extends Component<
  BoxAndWhiskerPlotProps,
  BoxAndWhiskerPlotState
> {
  constructor(props: BoxAndWhiskerPlotProps) {
    super(props);
    this.state = {
      options: props.options || {},
      series: props.series || [],
    };
  }

  componentDidUpdate(prevProps: BoxAndWhiskerPlotProps) {
    // Check if options or series props have changed
    if (
      JSON.stringify(prevProps.options) !==
        JSON.stringify(this.props.options) ||
      JSON.stringify(prevProps.series) !== JSON.stringify(this.props.series)
    ) {
      // Update state with new props
      this.setState({
        options: this.props.options || this.state.options,
        series: this.props.series || this.state.series,
      });
    }
  }

  render() {
    const { options, series } = this.state;
    const { height = "100%", width = "100%", fillContainer } = this.props;

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          minHeight: fillContainer ? 0 : 200,
        }}
      >
        <Chart
          type="boxPlot"
          options={options}
          series={series as any}
          height={height}
          width={width}
        />
      </div>
    );
  }
}

export default BoxAndWhiskerPlot;
